module.exports = __webpack_public_path__ + "static/media/bar_table-50.90a888dd.png";